import React from 'react';
import PropTypes from 'prop-types';
import StarsCounter from './StarsCounter';

const KEY = 'average_valuation_value';

const StarsCounters = ({ list = [], total = 0 }) => (
    <table className="stars-counters">
        <tbody>
            {list
                .sort((starCounterA, starCounterB) => starCounterB[KEY] - starCounterA[KEY])
                .map((counter) => {
                    const averageValue = counter[KEY];
                    return (
                        <StarsCounter key={averageValue} total={total} rating={counter.count} value={averageValue} />
                    );
                })}
        </tbody>
    </table>
);

StarsCounters.propTypes = {
    list: PropTypes.arrayOf(
        PropTypes.shape({
            [KEY]: PropTypes.number,
            count: PropTypes.number,
        })
    ),
    total: PropTypes.number,
};

export default StarsCounters;
